// extracted by mini-css-extract-plugin
export default {"nameNumber":"list_nameNumber__c-4-G","actionsDiv":"list_actionsDiv__m9lBd"};